// @flow

const allowedFileFormatsRaw = [
  {
    contentType: "application/pdf",
    extension: "pdf"
  },
  {
    contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extension: "docx"
  },
  {
    contentType: "application/msword",
    extension: "doc"
  },
  {
    contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extension: "xlsx"
  },
  {
    contentType: "application/vnd.ms-excel",
    extension: "xls"
  },
  {
    contentType: "image/jpeg",
    extension: "jpg"
  },
  {
    contentType: "image/png",
    extension: "png"
  },
  {
    contentType: "image/bmp",
    extension: "bmp"
  },
  {
    contentType: "image/tiff",
    extension: "tiff"
  }
];

export const extractFileExtension = (passedType: string = ""): string =>
  allowedFileFormatsRaw.reduce(
    (acc, { contentType, extension }) => (contentType === passedType ? extension : acc),
    ""
  );

export const allowedFileFormats = allowedFileFormatsRaw.map(
  fileFormat => `.${fileFormat.extension}`
);
